import { AnswerComment } from 'src/api';

/**
 * Is Answer Comment
 */
const isAnswerComment = (value: any): value is AnswerComment =>
  value.hasOwnProperty('answer') && !!value.answer;

export { isAnswerComment };
